import { formControlBuilder } from '../form-control/form-control-builder-factory';
import { nestedPropertyBuilder } from '../nested-property/nested-property-builder-factory';
import { email } from '../validations';
import { arrayPropertyBuilder } from '../array-property/array-property-builder-factory';
var PropertyMappingBuilderImpl = /** @class */ (function () {
    function PropertyMappingBuilderImpl() {
        this.array = arrayPropertyBuilder();
        this.boolean = formControlBuilder({
            serializer: function (model, _, value, attribute) {
                model[attribute] = !!value;
            },
        });
        this.email = formControlBuilder({
            validations: [email],
        });
        this.generic = formControlBuilder();
        this.int = formControlBuilder({
            serializer: function (model, _, value, attribute) {
                model[attribute] = parseInt(value, 10);
            },
        });
        this.nested = nestedPropertyBuilder();
        this.number = formControlBuilder({
            serializer: function (model, _, value, attribute) {
                model[attribute] = Number(value);
            },
        });
    }
    return PropertyMappingBuilderImpl;
}());
export { PropertyMappingBuilderImpl };
//# sourceMappingURL=property-mapping-builder-impl.js.map